import { useMediaQuery } from '@mui/material';

export const useResponsive = () => {
  const isMobile = useMediaQuery('(max-width:767px)');
  const isTablet = useMediaQuery('(max-width:1200px)');
  const isLaptop = useMediaQuery('(max-width:1400px)');

  return { isMobile, isTablet, isLaptop };
};
